import FullView from './FullView';
import MinimalView from './MinimalView';
import RecambistaBusquedaView from './RecambistaBusquedaView';

const views = {
    recambistaBusqueda: RecambistaBusquedaView,
    minimal: MinimalView,
    full: FullView,
};

const AlternativaDetalleAlternativasGrid = ({
    variant = 'full',
    alternativa,
    precioOk,
    confirmPrice = false,
    onConfirmPriceChange,
    onCopyPiezaUrl,
}) => {
    if (!alternativa) {
        return null;
    }

    const piezas = alternativa?.piezas ?? [];
    const View = views[variant] ?? FullView;

    return (
        <View
            alternativa={alternativa}
            piezas={piezas}
            precioOk={precioOk}
            confirmPrice={confirmPrice}
            onConfirmPriceChange={onConfirmPriceChange}
            onCopyPiezaUrl={onCopyPiezaUrl}
        />
    );
};

export default AlternativaDetalleAlternativasGrid;
